/* @ngInject */
function fontsBaseService (ConnectorWebService, CONSTANTS, Utils, $q, $cookies) {
  const aFontFamiliesAlreadyIncludedInCss = []

  const service = {
    getFonts,
    loadFontsOnCSS,
    getCompanyFontConfiguration
  }
  return service

  /**
  * Get fonts list for brand section
  * @param {Object} options
  * @param {number} options.brandSectionCategoryId - brand section category id
  * @param {boolean} options.editorEnabled - only fonts that can be used on the editor
  * @param {number} options.top - pagination
  * @param {number} options.skip - pagination
  */
  function getFonts (options) {
    let url = Utils.fnAddTopSkipQueriesToUrl(CONSTANTS.URL_FONTS, options.top, options.skip)

    if (options.brandSectionCategoryId || options.editorEnabled) {
      url = Utils.fnAddQueryToUrl(url, { brandSectionCategoryId: options.brandSectionCategoryId, editorEnabled: options.editorEnabled })
    }

    return ConnectorWebService.get(url)
  }

  /**
  * Add CSS classes to load fonts in the browser
  * @param [{Object}] fonts
  * @param {number} fonts.id
  * @param {String} fonts.familyName
  */
  function loadFontsOnCSS (fonts) {
    if (!fonts || !fonts.length) {
      return $q.resolve()
    }

    return $q((resolve, reject) => {
      const fontsPromise = fonts.map(font => {
        if (aFontFamiliesAlreadyIncludedInCss.includes(font.familyName)) {
          return $q.resolve()
        }

        let url = Utils.fnReplaceStringParams(CONSTANTS.URL_FONTS_ID, [font.id])
        url = Utils.fnAddQueryToUrl(url, { jwt: $cookies.get('jwt') })

        const loadFont = new FontFace(font.familyName, `url(${url})`)
        return loadFont.load()
          .then(f => {
            aFontFamiliesAlreadyIncludedInCss.push(font.familyName)
            document.fonts.add(f)

            return f
          }).catch(() => {
            console.error(`Font ${font.id} failed to load`)
            return $q.resolve()
          })
      })

      resolve($q.all(fontsPromise))
    })
  }

  function getCompanyFontConfiguration () {
    return ConnectorWebService.get(CONSTANTS.URL_CUSTOMER_FONT_CONFIGURATION)
  }
}

export { fontsBaseService }
